module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "文件编辑",
      "visible": _vm.formVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.formVisible = $event
      }
    }
  }, [_c('el-col', {
    staticStyle: {
      "margin-bottom": "20px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "formd",
    attrs: {
      "model": _vm.formData,
      "label-width": "80px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分类",
      "prop": "fenlei"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "选择分类"
    },
    model: {
      value: (_vm.formData.fenlei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "fenlei", $$v)
      },
      expression: "formData.fenlei"
    }
  }, _vm._l((_vm.fenleis), function(fl) {
    return _c('el-option', {
      key: 'fl1-' + fl.Id,
      attrs: {
        "label": fl.Name,
        "value": fl.Id + ''
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "金额",
      "prop": "amount"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.amount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "amount", $$v)
      },
      expression: "formData.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "加密"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('el-switch', {
    staticStyle: {
      "margin": "10px"
    },
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.formData.jm),
      callback: function($$v) {
        _vm.$set(_vm.formData, "jm", $$v)
      },
      expression: "formData.jm"
    }
  }), _vm._v(" "), (_vm.formData.jm) ? _c('el-input', {
    attrs: {
      "auto-complete": "off",
      "placeholder": "请输入密码"
    },
    model: {
      value: (_vm.formData.pass),
      callback: function($$v) {
        _vm.$set(_vm.formData, "pass", $$v)
      },
      expression: "formData.pass"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "描述"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.formData.descpt),
      callback: function($$v) {
        _vm.$set(_vm.formData, "descpt", $$v)
      },
      expression: "formData.descpt"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.formVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.formLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.formSubmit($event)
      }
    }
  }, [_vm._v("确认")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fbbca98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ruis/file/FileEdit.vue
// module id = 1161
// module chunks = 1